import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

import { demoModeLabel, isDemoMode } from 'config/demo-mode';

export default function DemoModeIndicator() {
  if (!isDemoMode) return null;

  return (
    <Tooltip title={demoModeLabel}>
      <Chip color="warning" label="Demo Mode" size="small" variant="outlined" sx={{ fontWeight: 700, maxWidth: { xs: 94, sm: 'none' } }} />
    </Tooltip>
  );
}
